var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconParkOutline = function SvgIconParkOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 43.4166C37.1338 43.4166 42.9168 37.6336 42.9168 30.4999C42.9168 23.3662 37.1338 17.5833 30.0002 17.5833C22.8665 17.5833 17.0835 23.3662 17.0835 30.4999C17.0835 37.6336 22.8665 43.4166 30.0002 43.4166Z",
    stroke: "url(#paint0_linear_34_3717)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0418 39.5416L37.1043 37.6041M20.9585 21.4583L22.896 23.3958",
    stroke: "url(#paint1_linear_34_3717)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.542 35.0207L24.0955 33.0832M24.0955 33.0832L26.1253 25.979L28.1552 33.0832M24.0955 33.0832H28.1552M28.7087 35.0207L28.1552 33.0832M37.1045 30.4998C37.1045 33.729 34.7911 35.0207 31.9378 35.0207V25.979C34.7911 25.979 37.1045 27.2707 37.1045 30.4998Z",
    stroke: "url(#paint2_linear_34_3717)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_3717",
    x1: -1.06782,
    y1: 30.4999,
    x2: 48.5594,
    y2: 30.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_3717",
    x1: 8.25257,
    y1: 30.4999,
    x2: 42.9916,
    y2: 30.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34_3717",
    x1: 14.0126,
    y1: 30.4998,
    x2: 40.0668,
    y2: 30.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconParkOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/IconParkOutline.eff4a8ef7b1675fe18efff4ff6e35e33.blank.svg";